import React, { useState } from "react";
import {
  Clock,
  CheckCircle,
  FileText,
  AlertCircle,
  Calendar,
} from "lucide-react";

const iconMap = {
  scheduled: <Calendar className="w-4 h-4 text-blue-500" />,
  completed: <CheckCircle className="w-4 h-4 text-green-500" />,
  note: <FileText className="w-4 h-4 text-yellow-500" />,
  issue: <AlertCircle className="w-4 h-4 text-red-500" />,
  default: <Clock className="w-4 h-4 text-gray-400" />,
};

const TimelineView = ({ groupedTimeline }) => {
  if (!groupedTimeline || Object.keys(groupedTimeline).length === 0) {
    return (
      <div className="text-gray-500 dark:text-gray-400 italic text-sm mb-4">
        No timeline data available.
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {Object.entries(groupedTimeline).map(([interviewId, events]) => (
        <InterviewTimeline key={interviewId} events={events} />
      ))}
    </div>
  );
};

const InterviewTimeline = ({ events }) => {
  const [open, setOpen] = useState(true);

  if (!events || events.length === 0) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow p-5">
        <div className="text-gray-500 dark:text-gray-400 italic text-sm">
          No timeline data available.
        </div>
      </div>
    );
  }

  const { company, position } = events[0] || {};

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl shadow p-5">
      <div
        className="flex items-center justify-between cursor-pointer mb-3"
        onClick={() => setOpen(!open)}
      >
        <h3 className="text-md font-semibold text-gray-800 dark:text-white">
          {position} @ {company}
        </h3>
        <button className="text-sm text-blue-500 hover:underline">
          {open ? "Hide" : "Show"} Timeline
        </button>
      </div>

      {open && (
        <ol className="relative border-l border-gray-300 dark:border-gray-600 pl-4 space-y-5">
          {events.map((item, index) => {
            const Icon = iconMap[item.type] || iconMap.default;

            return (
              <li key={index} className="relative">
                <span className="absolute -left-3 top-1">{Icon}</span>
                <time className="block text-sm text-gray-500 dark:text-gray-400">
                  {new Date(item.timestamp).toLocaleDateString()} –{" "}
                  {new Date(item.timestamp).toLocaleTimeString()}
                </time>
                <p className="text-base font-medium text-gray-900 dark:text-white">
                  {item.role} @ {item.company}
                </p>
                <p className="text-sm text-gray-700 dark:text-gray-300">
                  {item.action}
                </p>
              </li>
            );
          })}
        </ol>
      )}
    </div>
  );
};

export default TimelineView;
